import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import { Gift } from '@wix/wix-ui-icons-common/lazy';
import { useIsMobile } from '@wix/core-domain-search';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { useWhoisMobileOptimizations } from '../../hooks/useWhoisMobileOptimizations';
import { BaseVoucherBanner } from './VoucherBanner';
export const WhoisVoucherBanner = /*#__PURE__*/forwardRef((_props, ref) => {
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const isMobile = useIsMobile();
  const mobileOptimizations = useWhoisMobileOptimizations();
  return /*#__PURE__*/React.createElement(BaseVoucherBanner, _extends({
    ref: ref,
    icon: /*#__PURE__*/React.createElement(Gift, null),
    content: t(isMobile ? 'domain_search_gate.whois_results.mobile.promo_banner.title' : 'domain_search_gate.whois_results.mobile.modal.free_domain_promo.description')
  }, mobileOptimizations ? {
    padding: '6px 16px',
    borderRadius: '12px 12px 0 0'
  } : {}));
});
//# sourceMappingURL=WhoisVoucherBanner.js.map